module.exports = __webpack_public_path__ + "account/assets/secondary.409e1763.svg";